





















































































































































































































































































































































import { Component, Watch } from "vue-property-decorator";
import Vue from "vue";
import RencanaKontrol from "@/services/RencanaKontrol";
import EncounterIndex from "@/services/EncounterIndex";
import DialogSyncSrk from "@/components/rencanaKontrol/DialogSyncSrk.vue";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { localISODate, parseLocalDate } from "@/utils/localDate";
import { isGadar, pemeriksaanRouteName } from "@/utils/unit";
import {
  REFERENSI_LABEL,
  STATUS_SRK_META,
  tglPanjang
} from "@/utils/rencanaKontrol";
import { storeDokter } from "@/store/modules/dokter";
import { storeUnit } from "@/store/modules/unit";
import { userModule } from "@/store/modules/user";
import {
  RencanaKontrolFilter,
  RencanaKontrolListParams,
  RencanaKontrolRow
} from "@/types/rencanaKontrol";

function filterDefault(): RencanaKontrolFilter {
  const user = userModule.user;

  return {
    tglSurat: null,
    tglKontrol: localISODate(new Date()),
    dpjpId: userModule.isDokter && user && user.id ? Number(user.id) : null,
    unitId: null
  };
}

let urutanRequest = 0;

@Component({
  components: { DialogSyncSrk, VCDateTimePicker }
})
export default class RencanaKontrolSrkPage extends Vue {
  items: RencanaKontrolRow[] = [];
  totalItems = 0;
  lastPage = 1;
  loading = false;

  itemsPerPageOptions = [
    { text: "10 per halaman", value: 10 },
    { text: "25 per halaman", value: 25 },
    { text: "50 per halaman", value: 50 },
    { text: "100 per halaman", value: 100 }
  ];

  filter: RencanaKontrolFilter = filterDefault();

  applied: RencanaKontrolFilter = filterDefault();

  cari = "";

  cariAktif = "";

  options = { page: 1, itemsPerPage: 10 };

  dialogSync = false;

  itemSync: RencanaKontrolRow | null = null;

  busyId: number | null = null;

  statusMeta = STATUS_SRK_META;

  headers = [
    { text: "No. RM", value: "pasien.rm" },
    { text: "Nama Pasien", value: "pasien.nama" },
    { text: "DPJP", value: "dpjp.nama" },
    { text: "Tgl. Kontrol", value: "tgl_kontrol" },
    { text: "Tgl. Surat", value: "tgl_surat" },
    { text: "Klinik Tujuan Kontrol", value: "klinik.nama" },
    { text: "Diagnosis", value: "diagnosis" },
    { text: "Referensi", value: "referensi" },
    { text: "Keterangan", value: "keterangan" },
    { text: "Status SRK", value: "status_srk" },
    { text: "Aksi", value: "aksi", align: "end" }
  ];

  created() {
    if (!storeDokter.listAll.length) {
      storeDokter.act_dokter_all();
    }

    if (!storeUnit.unitPagi.length) {
      storeUnit.act_on_all_pagi();
    }
  }

  get dokterItems() {
    const list = storeDokter.listAll;
    const dipilih = this.filter.dpjpId;

    if (dipilih && !list.some(d => Number(d.id) === dipilih)) {
      const user = userModule.user;

      if (user && Number(user.id) === dipilih) {
        return [{ id: dipilih, nama: user.nama }, ...list];
      }
    }

    return list;
  }

  get klinikItems() {
    return storeUnit.unitPagi;
  }

  get cariTrim(): string {
    return (this.cari || "").trim();
  }

  get modeCari(): boolean {
    return this.cariAktif !== "";
  }

  get filterBerubah(): boolean {
    return JSON.stringify(this.filter) !== JSON.stringify(this.applied);
  }

  get bisaReset(): boolean {
    const bawaan = JSON.stringify(filterDefault());

    return (
      JSON.stringify(this.filter) !== bawaan ||
      JSON.stringify(this.applied) !== bawaan
    );
  }

  get tglSuratDate(): Date | null {
    return parseLocalDate(this.filter.tglSurat);
  }

  get tglKontrolDate(): Date | null {
    return parseLocalDate(this.filter.tglKontrol);
  }

  get rentangTampil(): string {
    if (!this.items.length) return "0";

    const awal = (this.options.page - 1) * this.options.itemsPerPage + 1;

    return `${awal} - ${awal + this.items.length - 1}`;
  }

  setTglSurat(val: Date | null) {
    this.filter.tglSurat = val ? localISODate(val) : null;
  }

  setTglKontrol(val: Date | null) {
    this.filter.tglKontrol = val ? localISODate(val) : null;
  }

  tglPanjang(iso: string | null): string {
    return tglPanjang(iso);
  }

  labelReferensi(item: RencanaKontrolRow): string {
    return item.referensi ? REFERENSI_LABEL[item.referensi] : "-";
  }

  identitasPasien(item: RencanaKontrolRow): string {
    const umur = item.pasien.umur ? item.pasien.umur.toLowerCase() : null;
    const jk =
      item.pasien.sex === "L"
        ? "Laki-laki (L)"
        : item.pasien.sex === "P"
        ? "Perempuan (P)"
        : null;

    return [umur, jk].filter(Boolean).join(" • ") || "-";
  }

  @Watch("options", { deep: true })
  onOptionsChange() {
    this.getList();
  }

  terapkan() {
    this.applied = { ...this.filter };
    this.cari = "";
    this.cariAktif = "";
    this.muatHalamanPertama();
  }

  resetFilter() {
    this.filter = filterDefault();
    this.terapkan();
  }

  cariData() {
    if (!this.cariTrim) return;

    this.cariAktif = this.cariTrim;
    this.muatHalamanPertama();
  }

  batalCari() {
    this.cari = "";

    if (!this.modeCari) return;

    this.cariAktif = "";
    this.muatHalamanPertama();
  }

  muatHalamanPertama() {
    if (this.options.page !== 1) {
      this.options = { ...this.options, page: 1 };
    } else {
      this.getList();
    }
  }

  changePerPage(val: number) {
    this.options = { ...this.options, itemsPerPage: val, page: 1 };
  }

  getList() {
    const urutan = ++urutanRequest;
    const f = this.applied;
    const params: RencanaKontrolListParams = {
      page: this.options.page,
      per_page: this.options.itemsPerPage
    };

    if (this.modeCari) {
      params.q = this.cariAktif;
    } else {
      if (f.tglSurat) params.tgl_surat = f.tglSurat;
      if (f.tglKontrol) params.tgl_kontrol = f.tglKontrol;
      if (f.dpjpId) params.dpjp_id = f.dpjpId;
      if (f.unitId) params.unit_id = f.unitId;
    }

    this.loading = true;

    RencanaKontrol.getList(params)
      .then(resp => {
        if (urutan !== urutanRequest) return;

        this.items = resp && resp.data ? resp.data : [];
        this.totalItems = resp && resp.meta ? resp.meta.total : 0;
        this.lastPage = resp && resp.meta ? resp.meta.last_page || 1 : 1;
      })
      .catch(() => {
        if (urutan !== urutanRequest) return;

        this.items = [];
        this.totalItems = 0;
        this.lastPage = 1;
      })
      .finally(() => {
        if (urutan === urutanRequest) {
          this.loading = false;
        }
      });
  }

  bukaSync(item: RencanaKontrolRow) {
    this.itemSync = item;
    this.dialogSync = true;
  }

  setelahSync(payload: { row: RencanaKontrolRow | null; berhasil: boolean }) {
    const row = payload.row;

    if (row) {
      const idx = this.items.findIndex(i => i.id === row.id);

      if (idx >= 0) {
        this.items.splice(idx, 1, row);
      }

      this.itemSync = row;
    }

    if (payload.berhasil) {
      this.dialogSync = false;
    }
  }

  async lihatPemeriksaan(item: RencanaKontrolRow) {
    const params = { register: String(item.register_id), rm: item.pasien.rm };
    const rute = pemeriksaanRouteName(item.register_unit);

    if (rute === "pemeriksaan-ranap") {
      this.busyId = item.id;

      await EncounterIndex.regRanap(item.register_id, item.pasien.rm).catch(
        () => undefined
      );

      this.busyId = null;

      this.$router
        .push({ name: rute, params, query: { topTab: "tab-rekam-medis" } })
        .catch(() => undefined);

      return;
    }

    this.$router
      .push({
        name: rute,
        params: isGadar(item.register_unit) ? params : { ...params, page: "tab-suket" }
      })
      .catch(() => undefined);
  }
}
